import { render, staticRenderFns } from "./UserRegistrationForm_v2.vue?vue&type=template&id=4c132a8e&scoped=true&"
import script from "./UserRegistrationForm_v2.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationForm_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c132a8e",
  null
  
)

export default component.exports